export default __webpack_public_path__ + "static/media/mt5_win.574ea4d6.png";